import React from 'react';
import { PropTypes } from 'prop-types';
import { Column } from 'components/shared/Layout';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import LoyaltyPointsInfos from 'components/shared/LoyaltyPointsInfos';
import { InfoLabel, InfoContainer } from '../Info/Info.styles';

const InfoWithPrice = ({ currency, value, price, pricePoints, labelId, className, dataId, dataCy, values = '', fixed = false }) => (
  <InfoContainer className={className} data-id={dataId} data-cy={dataCy} gutter="0px">
    <Column className="label" span={3}>
      <InfoLabel>
        <FormattedMessage id={labelId} values={{ direction: values }} />
      </InfoLabel>
      :
    </Column>

    {!fixed ? (
      <>
        <Column className="value" data-id={`count-${dataId}`} span={4} start={4}>
          {value}
        </Column>
        <Column className="price" data-id={`price-${dataId}`} span={4} start={8}>
          <FormattedCurrency currency={currency} amount={price || 0} />
          {!!pricePoints && <LoyaltyPointsInfos dataId="points-details" id="searchResults.pts" values={pricePoints} />}
        </Column>
      </>
    ) : (
      <>
        <Column className="price" data-id={`price-${dataId}`} span={4} start={4}>
          <FormattedCurrency currency={currency} amount={price || 0} />
          {!!pricePoints && <LoyaltyPointsInfos dataId="points-details" id="searchResults.pts" values={pricePoints} />}
        </Column>
      </>
    )}
  </InfoContainer>
);

InfoWithPrice.propTypes = {
  currency: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelId: PropTypes.string,
  className: PropTypes.string,
  dataId: PropTypes.string,
  fixed: PropTypes.bool,
  pricePoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  values: PropTypes.string,
  dataCy: PropTypes.string
};

export default InfoWithPrice;
